import Vue from 'vue'
import Vuex from 'vuex'
import VueMoment from 'vue-moment'
import nl2br from 'vue-nl2br'
import moment from 'moment/moment'
import flatPickr from 'vue-flatpickr-component'
import SharedFilters from '../shared/vue/Filters'

import '../shared/component/Form'

Vue.use(Vuex)
Vue.use(SharedFilters)
Vue.use(VueMoment, { moment })
Vue.component('flatPickr', flatPickr)
Vue.component('nl2br', nl2br)

Vue.directive('focus', {
  inserted(el) {
    el.focus()
  },
})

Vue.filter('date', (value, format) => moment(value).format(format))

Vue.filter('date_ago', (value, noSuffix) => moment(value).fromNow(noSuffix))

Vue.filter('encodeUriComponent', (value) => encodeURIComponent(value))
